import type { ResponseType } from "PFTypes/propilot";
import type { FC } from "react";

import { GenericVariant, type VariantProps } from "./generic/generic_variant";

export const VARIANT_BY_TYPE: Record<ResponseType, FC<VariantProps>> = {
  generic: GenericVariant,
  system_error: GenericVariant
};
